<template>
    <div v-loading="fullLoading">
        <el-row>
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
                <el-form :inline="true" :model="filters">
                    <el-form-item>
                        <el-input v-model="filters.name" placeholder="Search" @change="filterZones"></el-input>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="24">
                <el-table :data="logsTable" stripe style="width: 100%; margin-bottom: 10px; font-size: 1rem"
                    cell-class-name="cellStyle">
                    <!-- <el-table-column v-show="false" :min-width="70" prop="noteId" label="ID"></el-table-column> -->
                    <el-table-column :min-width="150" prop="timeFormatted" label="Time" sortable></el-table-column>
                    <el-table-column :min-width="150" prop="category_type_name" label="Category"
                        sortable></el-table-column>
                    <el-table-column :min-width="150" prop="entity_type_name" label="Entity" sortable></el-table-column>
                    <el-table-column :min-width="150" prop="log_type_name" label="Log Type" sortable></el-table-column>
                    <el-table-column :min-width="150" prop="type_name" label="Type" sortable></el-table-column>
                    <el-table-column :min-width="150" prop="old_value" label="Old Value" sortable></el-table-column>
                    <el-table-column :min-width="150" prop="new_value" label="New Value" sortable></el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Axios from "axios"

import UserService from "@/api/user.service"
import util from '../common/js/util'

export default {
    components: {},
    props: {},
    data() {
        return {
            fullLoading: false,
            user: this.$session.get("User"),
            dataLoaded: false,
            allLogs: [],
            logsTable: [
            ],
            filters: {
                name: ""
            },
        }
    },
    methods: {
        filterZones() {
            if (this.filters.name.length > 0) {
                this.logsTable = this.allLogs.filter((entry) => (
                    entry.category_type_name.toLowerCase().includes(this.filters.name.toLowerCase()) ||
                    entry.log_type_name.toLowerCase().includes(this.filters.name.toLowerCase()) ||
                    entry.type_name.toLowerCase().includes(this.filters.name.toLowerCase())
                ))
            } else {
                this.logsTable = this.allLogs
            }
        },
        onSubmit() {
            console.log("submit!")
        },

        getData() {
            if (!this.$auth.isAuthenticated()) this.$auth.login()
            //Axios.defaults.baseURL = 'http://192.168.137.233:3000';
            Axios.all([
                UserService.getZoneLog(this.user.activeZone),
            ])
                .then(
                    Axios.spread((ZoneLogResponse) => {
                        console.log(ZoneLogResponse)
                        this.allLogs = ZoneLogResponse.data
                        this.logsTable = ZoneLogResponse.data
                        for (var entry of this.logsTable) {
                            if (entry.time) {
                                entry.timeFormatted = util.formatDate.format(new Date(entry.time), 'yyyy-MM-dd hh:mm')
                            }
                        }
                        this.dataLoaded = true
                    })
                )
                .catch((err) => {
                    console.log(err)
                })
        }

    },
    created() { },
    mounted() {
        this.getData()
        //this.polling = setInterval(this.getData, 10000)
    },
    beforeDestroy() {
        //clearInterval(this.polling)
    }
}
</script>

<style>
.el-table td {
    font-size: medium;
    white-space: pre-wrap;
    word-wrap: break-word
}

.el-table__body-wrapper {
    overflow: hidden;
}

.el-table .cell {
    white-space: pre-wrap
}
</style>



// WEBPACK FOOTER //
// ZoneLogs.vue?95b34b08